import {ClickDrawer} from '@app/modules/svg/service/tool/draw/mode/ClickDrawer';
import {Point} from '@app/modules/svg/model/Point';
import {ElementView} from '@app/modules/svg/element/ElementView';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';
import {Drawable} from '@app/modules/svg/service/tool/draw/type/Drawable';

export abstract class DrawTwoPoint extends ClickDrawer {
  public override makeMouseDown(position: Point, call: boolean = true): void {
    super.makeMouseDown(position, call);
    if (this.clicksCount === 2) {
      this.stopDrawing(call);
    }
  }

  protected override stopClickDrawing(call: boolean = true): void {
    if (!this._drawableElement) {return;}

    if (this.clicksCount === 1) {
      this.drawTool.container.remove(this._drawableElement as unknown as ElementView, true, false);
    } else {
      this._drawableElement.refPoint = this._drawableElement.center;
      if (call) {
        const drawableElementCopy: Drawable = this._drawableElement.copy;
        drawableElementCopy.index = this._drawableElement.index;
        this.drawTool.container.__call__(SVGEvent.ELEMENT_CREATED, {element: drawableElementCopy});
      }
    }
    this.drawTool.container.tools.drawTool.__drawingEnd__();
    this._drawableElement = undefined;
    this.clicksCount = 0;
    if (call) {
      this.drawTool.container.__call__(SVGEvent.STOP_CLICK_DRAWING);
      this.drawTool.container.__call__(SVGEvent.END_DRAWING, {drawer: this});
    }
  }
}
